import { useUser } from "@libs:react-query-auth";
import { Navigate } from "react-router";

import { DEFAULT_ROUTE_AFTER_LOGIN, Routes } from "@:constants";

export const Root = () => {
  const user = useUser();

  return (
    <>
      {user.data ? (
        <Navigate to={DEFAULT_ROUTE_AFTER_LOGIN} />
      ) : (
        <Navigate to={Routes.Login} />
      )}
    </>
  );
};
